const resource = '/admin/v1/applications/tags';

export default $axios => ({
  index() {
    return $axios.get(`${resource}`);
  },

  getListExceptId() {
    return $axios.get(`${resource}/get-list-except-id`);
  },

  show(id) {
    return $axios.get(`${resource}/${id}`);
  },

  create(payload) {
    return $axios.post(`${resource}`, payload);
  },

  update(id, payload) {
    return $axios.put(`${resource}/${id}`, payload);
  },

  delete(id) {
    return $axios.delete(`${resource}/${id}`);
  }
});
